import { render, staticRenderFns } from "./service_desk_list_app.vue?vue&type=template&id=7f8507b0"
import script from "./service_desk_list_app.vue?vue&type=script&lang=js"
export * from "./service_desk_list_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports